import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EventBusClickService {
  private _closeClicked = new BehaviorSubject<boolean>(false);

  public clickClose(closeClicked: boolean): void {
    this._closeClicked.next(closeClicked);
  }

  public closeClicked(): Observable<boolean> {
    return this._closeClicked.asObservable();
  }
}
